import React from 'react';

const SEOKeywords = () => {
    return (
        <div className="w-full px-4 py-4 bg-[#5b3410] text-center">
            <div className="text-base text-white font-medium leading-relaxed">
                • DPANNA • Satta Matka • Kalyan Matka • Mumbai Matka • Delhi Bazar • Milan Day • Milan Night • 
                Rajdhani Day • Rajdhani Night • Time Bazar • Main Bazar • Market Analysis • Lucky Number • 
                Panel Chart • Jodi Chart • Satta King • Daily Updates • Fast Matka Result • Matka Tips • 
                Golden Matka • Online Matka • Live Result
            </div>
        </div>
    );
};

export default SEOKeywords;
